import React from 'react';
import PropTypes from 'prop-types';

class Button extends React.Component {
  render() {
    const {
      children,
      onClick,
      className,
      disabled,
      animate,
      animationIcon,
      animationText,
      icon,
      type = 'button',
      isAnimate,
      ...rest
    } = this.props;

    const isAnimating = animate || isAnimate;

    const finalClassName = `button ${className || ''}`.trim();

    return (
      <button
        type={type}
        className={finalClassName}
        onClick={onClick}
        disabled={disabled || isAnimating}
        {...rest}
      >
        {isAnimating && animationIcon && <span className="button-animation-icon">{animationIcon}</span>}
        {isAnimating && !animationIcon && <i className="bx bx-loader-alt bx-spin button-animation-icon" />}
        {!isAnimating && icon && <span className="button-icon"><i className={icon}></i></span>}
        {isAnimating && animationText ? animationText : children}
      </button>
    );
  }
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  animate: PropTypes.bool,
  isAnimate: PropTypes.bool,
  animationIcon: PropTypes.node,
  animationText: PropTypes.string,
  icon: PropTypes.node,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

Button.defaultProps = {
  onClick: () => {},
  className: '',
  disabled: false,
  animate: false,
  animationIcon: '',
  animationText: '',
  icon: null,
  type: 'button',
};

export default Button;
